import { render, staticRenderFns } from "./ui-select.vue?vue&type=template&id=5b3d4d54&"
import script from "./ui-select.vue?vue&type=script&lang=ts&"
export * from "./ui-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports